export const state = {
  company: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/company/state.js